import { useState } from "react";

export interface ShopIPComparatorState {
    sourceId: number  | undefined;
    targetId: number  | undefined;
}

const useShopIPComparator = (sourceId: number | undefined, targetId: number | undefined) => {
    const [shopIPComparator, setShopIPComparator] = useState<ShopIPComparatorState>({ sourceId: sourceId , targetId: targetId  });
    return { shopIPComparator, setShopIPComparator };
};

export default useShopIPComparator;
